import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FiLogIn } from 'react-icons/fi';
import api from '../../lib/api';
import styles from './Affiliate.module.css';

const AffiliateLogin: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await api.post('/affiliates/login', { email, password });
      const token = res.data.token;
      if (token) {
        localStorage.setItem('affiliateToken', token);
        navigate('/affiliate/dashboard');
      } else {
        setError('Invalid response from server');
      }
    } catch (err: any) {
      setError(
        err?.response?.data?.error || 'Invalid credentials'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginPage}>
      <form className={styles.loginCard} onSubmit={handleSubmit}>
        <div className={styles.logo}>
          OFMIG<span>.SHOP</span>
        </div>
        <p className={styles.title}>Affiliate Login</p>

        <div className={styles.formGroup}>
          <label>Email</label>
          <input
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
          />
        </div>

        <div className={styles.formGroup}>
          <label>Password</label>
          <input
            type="password"
            className={styles.input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="********"
            required
          />
        </div>

        <button
          type="submit"
          className={styles.submitBtn}
          disabled={loading}
        >
          <FiLogIn size={16} />
          {loading ? 'Loading...' : 'Sign In'}
        </button>

        {error && <div className={styles.error}>{error}</div>}

        <div className={styles.linkText}>
          Don't have an account? <Link to="/affiliate/register">Register here</Link>
        </div>
      </form>
    </div>
  );
};

export default AffiliateLogin;
